import { get } from 'lodash';

export function urlIsValid(urlStr) {
  return /https?:\/\/[a-z0-9].+/.test(urlStr);
}

export function maxLength(len, error, str = '') {
  return get(str, 'length', 0) > len ? error : undefined;
}

export function required(value) {
  return value ? undefined : 'Required';
}
export function validURL(value) {
  return !value || urlIsValid(value)
    ? undefined
    : 'Must be a valid URL including protocol';
}



// WEBPACK FOOTER //
// ./src/client/helpers/validate.js